import resolveCompound from './resolveCompound';
import resolveImage from './resolveImage';

export const getFallbackImageVideo = ({ isMobile, mobileBackgroundImage, fallbackImage }: any) => {
  if (!isMobile) {
    return fallbackImage;
  }

  if (isMobile && mobileBackgroundImage) {
    return mobileBackgroundImage;
  }

  return fallbackImage;
};

const resolveVideo = ({ rawVal, page }: any) => {
  const compound = resolveCompound({ rawVal });

  return { ...compound, fallbackImage: resolveImage({ rawVal: compound.fallbackImage, page }) };
};

export default resolveVideo;
